import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    window.gtag("config", "G-TQCC5LXP7V", {
      page_path: location.pathname,
    });
  }, [location]);
}
